import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const CTA_URL = 'https://wa.me/17863763985';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/uTZG5K2BcyqsZi5cZa75st/Asset_21x.png';
export function LandingHero() {
  return <section className="w-full bg-white pt-8 pb-12 md:pt-12 md:pb-20 px-5" data-id="element-341">
      <div className="max-w-5xl mx-auto" data-id="element-342">
        {/* Logo */}
        <div className="flex justify-center mb-10 md:mb-14" data-id="element-343">
          <img src={LOGO_URL} alt="Brixen Credit" className="h-9 md:h-11 w-auto" data-id="element-344" />
        </div>

        <motion.div className="text-center max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-345">
          <h1 className="text-[28px] leading-tight sm:text-4xl md:text-5xl font-extrabold text-[#0A0A0A] tracking-tight mb-5" style={{
          fontFamily: 'Manrope, Inter, sans-serif'
        }} data-id="element-346">
            Compañía <span className="text-[#7B2FE0]" data-id="element-347">#1</span> en Restauración
            de Crédito en Estados Unidos
          </h1>

          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-348">
            Nos especializamos en ayudar a la comunidad hispana con un proceso
            express, personalizado y enfocado en resultados reales.
          </p>

          <a href={CTA_URL} className="inline-block w-full sm:w-auto" data-id="element-349">
            <motion.button type="button" whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} className="w-full sm:w-auto px-12 py-4 bg-[#7B2FE0] text-white font-bold text-base uppercase tracking-wide rounded-full shadow-lg shadow-[#7B2FE0]/30 hover:bg-[#6a23c7] transition-colors" data-id="element-350">
              Consulta Gratis
            </motion.button>
          </a>

          {/* Trust bar */}
          <div className="mt-8 flex items-center justify-center gap-2 flex-wrap" data-id="element-351">
            <div className="flex" data-id="element-352">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#00B67A] fill-[#00B67A]" data-id="element-353" />)}
            </div>
            <span className="text-sm font-semibold text-gray-700" data-id="element-354">
              4,9 en Trustpilot
            </span>
            <span className="text-gray-300" data-id="element-355">·</span>
            <span className="text-sm font-semibold text-gray-700" data-id="element-356">
              +5,000 Clientes Satisfechos
            </span>
          </div>
        </motion.div>

        {/* Logo marquee */}
        <div className="mt-12 md:mt-16 border-t border-gray-100 pt-8" data-id="element-357">
          <p className="text-center text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5" data-id="element-358">
            Trabajamos con las mejores plataformas del mercado
          </p>
          <div className="relative overflow-hidden" data-id="element-359">
            <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white to-transparent z-10" data-id="element-360" />
            <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white to-transparent z-10" data-id="element-361" />
            <motion.div className="flex items-center gap-x-12 w-max" animate={{
            x: ['0%', '-50%']
          }} transition={{
            duration: 18,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-362">
              {['Experian', 'Equifax', 'TransUnion', 'MyScoreIQ', 'IdentityIQ', 'Experian', 'Equifax', 'TransUnion', 'MyScoreIQ', 'IdentityIQ'].map((name, i) => <span key={`${name}-${i}`} className="text-lg md:text-xl font-bold text-gray-400 whitespace-nowrap" style={{
              fontFamily: 'Manrope, Inter, sans-serif'
            }} data-id="element-363">
                  {name}
                </span>)}
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}